export default __webpack_public_path__ + "static/media/kib.29dca4e9.png";